import styled from 'styled-components';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  margin: 0 30px;
  padding-bottom: 30px;

  &:not(:last-child) {
    margin-bottom: 30px;
    border-bottom: solid 1px ${({ theme }) => theme.hotelDetails.separator};
  }
`;

export const Fare = styled.h5`
  font-size: 14px;
  margin-top: 10px;
  color: ${({ theme }) => theme.hotelDetails.strongGrey};
`;

export const Description = styled.li`
  font-size: 14px;
  margin-top: 10px;
  list-style-type: disc;
  color: ${({ theme }) => theme.hotelDetails.strongGrey};
`;

export const Footer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 22px;
`;

export const Selection = styled(Button)`
  width: 150px;
  height: 56px;
  margin-top: 10px;
  margin-left: auto;
`;

export const ContentRefundableItems = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const Tag = styled.div`
  margin-top: 16px;
  padding-right: 5px;
`;
